export const DEFAULT_PIE_CHART_COLORS: Array<string> = [
  '#008EBF',
  '#005E7F',
  '#00BDFF',
  '#002F40',
  '#00AAE5',
  '#66d9ff'
];
export const DEFAULT_BAR_CHART_COLORS = ['#61A5ED', '#2652B2'];
export const DEFAULT_LINE_CHART_COLORS = [
  '#008EBF',
  '#005E7F',
  '#00BDFF',
  '#002F40',
  '#00AAE5'
];
export const DEFAULT_LINE_CHART_PREFIXES_BIGNUM = [
  { number: 1e3, prefix: 'K' },
  { number: 1e6, prefix: 'M' },
  { number: 1e9, prefix: 'B' },
  { number: 1e12, prefix: 'T' },
  { number: 1e15, prefix: 'P' },
  { number: 1e18, prefix: 'E' },
  { number: 1e21, prefix: 'Z' },
  { number: 1e24, prefix: 'Y' }
];
export const DEFAULT_CHART_FONT = 'Open Sans';
export const DEFAULT_CHART_FONT_SIZE = 12;
export const BAR_CHART_BALLOON_TEXT =
  "<b>[[title]]</b><br><span style='font-size:14px'>[[category]]: <b>[[value]]%</b></span>";
export type ChartType = 'double' | 'triple' | 'custom' | 'engagement';
